module.exports = __webpack_public_path__ + "img/cold-wallets.f8bb38ec.jpg";